import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ingresar-documento',
  templateUrl: './ingresar-documento.component.html',
  styleUrls: ['./ingresar-documento.component.css']
})
export class IngresarDocumentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
